import { withAppHOC } from "../../hoc";
import { StyledPageHeading, StyledPageBody } from "../../components/Styled";

const RefundPolicy = () => {
  return (
    <>
      <StyledPageHeading>
        <h1>Refund Policy</h1>
      </StyledPageHeading>
      <StyledPageBody>
        <p>your data goes here</p>
      </StyledPageBody>
    </>
  );
};

export default withAppHOC(RefundPolicy);
